import * as d3Array from "d3-array";
import dateFromApiFormat from "../date-from-api-format";

const FORCE_ORDER = [
    "People",
    "Bicycles",
    "Motorbikes",
    "Buses",
    "Cars",
    "Trucks",
];


const breakdownFuncs = {
    People: {
        "Gender": (countsRaw) => {
            return {
                "Male": countsRaw.Male.Total,
                "Female": countsRaw.Female.Total,
                "Unidentified Gender": countsRaw["Unidentified gender"].Total,
            }
        },
        "Age": (countsRaw) => countsRaw["Pedestrians by age"],
    },
    Bicycles: {
        "Types": (countsRaw) => countsRaw.Bicycle,
    }
}


const processVideoDetails = (details, breakdownCounts) => {
    console.time("Process Video Details");

    const allValues = [];
    // TODO: wrap around midnight?
    const dateRaw = details.Data.Date;
    const allTimes = details.Time.map(timestamp => dateFromApiFormat(dateRaw, timestamp));

    const { PlotData, Totals } = details.Counts;
    const timeBetweenFrames = dateFromApiFormat(dateRaw, details.Time[1]) - dateFromApiFormat(dateRaw, details.Time[0])
    let plots = Object.keys(PlotData)
    .sort((a, b) => FORCE_ORDER.indexOf(a) - FORCE_ORDER.indexOf(b))
    .map(plotKey => {
        const plot = PlotData[plotKey];
        const total = Totals[plotKey];
        const plotData = allTimes.map((timestamp, index) => {
            const value = plot[index];
            allValues.push(value);
            const timeExtents = [
                timestamp,
                new Date(timestamp.getTime() + timeBetweenFrames),
            ]
            return {
                timestamp,
                timeExtents,
                value,
            }
        });


        let breakdown = undefined;
        const breakdownFuncsForPlot = breakdownFuncs[plotKey];
        if (breakdownFuncsForPlot) {
            breakdown = Object.keys(breakdownFuncsForPlot).map(breakdownKey => {
                
                const breakdownFunc = breakdownFuncsForPlot[breakdownKey];
                const breakdownResults = breakdownFunc(breakdownCounts);

                const items = Object.keys(breakdownResults)
                .map(itemKey => {
                    return {
                        label: itemKey,
                        value: breakdownResults[itemKey],
                    }
                })
                .filter(item => item.label !== "Total");

                return {
                    breakdownKey,
                    items,
                }
            })
        }
        
        return {
            plotKey,
            total,
            plotData,
            breakdown,
        }
    })


    const dataExtent = d3Array.extent(allValues);
    const timeExtent = d3Array.extent(allTimes);
    const timeInterval = d3Array.min(allTimes, (d, i) => {
        if (i === 0) return Number.POSITIVE_INFINITY;
        const prev = allTimes[i - 1];
        return (d - prev) / 1000;
    })
    const timeLength = (timeExtent[1] - timeExtent[0]) / 1000;

    console.timeEnd("Process Video Details");
    return {
        plots,
        extents: {
            data: dataExtent,
            time: timeExtent,
        },
        timeLength,
        timeInterval,
    }
}

export default processVideoDetails;


// WEBPACK FOOTER //
// ./src/modules/data/process-video-details.js